import React from 'react';
import Link from 'next/link';

export default function IdeaBanner() {
  return (
    <section className="relative w-full max-w-[1100px] mx-auto my-16 px-4 md:px-8">
      <div className="relative overflow-hidden rounded-[2.5rem] bg-[#111111] py-16 px-6 md:px-12 flex flex-col items-center justify-center text-center shadow-2xl">
        {/* Soft glowing ambient lights */}
        <div className="absolute -bottom-32 -left-32 w-[400px] h-[400px] bg-[#f58327]/10 rounded-full blur-[100px] pointer-events-none"></div>
        <div className="absolute -top-32 -right-32 w-[400px] h-[400px] bg-[#f58327]/10 rounded-full blur-[100px] pointer-events-none"></div>

        {/* Content */}
        <div className="relative z-10 max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-[32px] font-semibold text-white tracking-tight mb-4">
            Got an idea? Let's build it.
          </h2>
          <p className="text-gray-400 mb-8 text-sm md:text-base font-light">
            Join 50+ businesses who trusted us with their vision.
          </p>
          <Link 
            href="/contact" 
            className="group inline-flex items-center justify-center bg-[#f58327] text-black font-semibold text-sm py-3 px-8 rounded-xl transition-all duration-300 shadow-[0_0_15px_rgba(245,131,39,0.25)]"
          >
            Start your project 
            <span className="ml-2 font-bold transition-transform duration-300 group-hover:translate-x-1">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
